import type { FC } from 'react'
import React from 'react'
import styles from './UseMapBlock.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import { useErrorHandling } from '@/tools/o11y/client'
import { IconBlob, IconBlobType, IconSize, LocationPinIcon } from '@/tools/ui'

interface Props {
  onClick: () => void
}
export const UseMapBlock: FC<Props> = ({ onClick }) => {
  const { t } = useLocalisation()
  const { withErrorTracking } = useErrorHandling()

  const handleOnClick = withErrorTracking(() => {
    onClick()
  })

  return (
    <div className={styles.useMapBlock} onClick={handleOnClick}>
      <IconBlob
        className={styles.locationIcon}
        icon={LocationPinIcon}
        size={IconSize.medium}
        type={IconBlobType.positive}
      />
      <div>
        <p className={styles.title}>{t('address-search.helper')}</p>
        <p className={styles.subtitle}>{t('address-search.map-link')}</p>
      </div>
    </div>
  )
}
